import { createActionGroup } from '@ngrx/store';

export const SocieteTerritoirePatrimoineActions = createActionGroup({
  source: 'Societe Territoire Patrimoine',
  events: {}
});
